import { Button, withStyles } from '@material-ui/core';

export const WhiteButton = withStyles(() => ({
  root: {
    color: 'black',
    backgroundColor: 'white'
  }
}))(Button);

WhiteButton.displayName = 'WhiteButton';
